import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=60db6174&scoped=true&"
import script from "./agb.vue?vue&type=script&lang=js&"
export * from "./agb.vue?vue&type=script&lang=js&"
import style0 from "./agb.vue?vue&type=style&index=0&id=60db6174&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db6174",
  null
  
)

export default component.exports